import React, { Component } from 'react';
import { FormGroup, Label, Form} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';

export class ChangePassword extends Component {
	displayName = ChangePassword.name;

  constructor(props) {
	super(props);

	this.state = {
		tempPassword: '',
		newPassword: '',
		doubleNewPassword: ''
	};

	this.login = this.login.bind(this);
  }

  login(e) {
	e.preventDefault();

	var data = new FormData();

	if (this.state.newPassword !== this.state.doubleNewPassword) {
		toast.Error('Пароли не совпадают');

		return;
	}

	data.append('newPassword', this.state.newPassword);
	data.append('tempPassword', this.state.tempPassword);


	const requestOptions = {
		method: 'POST',
		credentials: 'same-origin',
		body: data
	};

	fetch('api/DataforDB/ChangePassword', requestOptions)
		.then(response => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
		})
		.then(() => {
			if (data) {
				this.setState({
					tempPassword: '',
					newPassword: '',
					doubleNewPassword: ''
				}, () => toast.success('Пароль успешно изменен.'))
			} else {
				toast.error('Произошла ошибка. Логин или пароль не верный.')
			}
		})
		.catch(error => toast.error('Произошла ошибка при попытке смены пароля.'));
  }

  render() {
	  return (
		  <React.Fragment>
			<ToastContainer/>
			<Form className='flex container' onSubmit={this.login}>
			<div className='login-form'>
				<h4>Смена пароля</h4>
				<FormGroup>
					<Label>
						Старый пароль:
				<input
							name='pass'
							className='form-control'
							type='password'
							value={this.state.tempPassword}
							onChange={e => {
								var value = e.target.value;
								this.setState({ tempPassword: value })
							}}
						/>
					</Label>
				</FormGroup>
				<FormGroup>
					<Label>
						Новый пароль:
						<input
							name= 'pass'
							className= 'form-control'
							type='password'
							value={this.state.newPassword}
							onChange={e => {
								var value = e.target.value;
								this.setState({ newPassword: value })
							}}
						/>
					</Label>
				</FormGroup>
				<FormGroup>
					<Label>
						Повторите новый пароль:
						<input
							name='pass'
							className='form-control'
							type='password'
							value={this.state.doubleNewPassword}
							onChange={e => {
								var value = e.target.value;
								this.setState({ doubleNewPassword: value })
							}
							}
						/>
					</Label>
				</FormGroup>
				<button className='btn btn-primary' type='submit'>Сменить</button>
			</div>
		</Form>
	  </React.Fragment>
	);
  }
}
